import { jsx, jsxs } from "react/jsx-runtime";
import { isCallState, isOutputState } from "./types.js";
import { toolOutputToFeaturedProduct, toolProductToSectionProduct } from "./utils.js";
import { FeaturedProductWidget } from "../FeaturedProductWidget.js";
import { CollapsibleProductSummary } from "./CollapsibleProductSummary.js";
function ProductDetailsPart({
  part,
  onProductClick,
  pdpStacklineSku
}) {
  var _a;
  if (isCallState(part.state)) return /* @__PURE__ */ jsx("div", { className: "concierge-loading", children: "Loading product details..." });
  const output = part.output;
  if (isOutputState(part.state) && ((_a = output == null ? void 0 : output.products) == null ? void 0 : _a.length) && output.products.length > 0) {
    const products = output.products;
    const isPdpContext = !!(pdpStacklineSku && products.every((p) => p.stacklineSku === pdpStacklineSku)) || !!output.fromPdp;
    if (isPdpContext && output.featuredProduct) {
      const product = toolOutputToFeaturedProduct(output.featuredProduct);
      return /* @__PURE__ */ jsx(CollapsibleProductSummary, { product, defaultOpen: false, children: /* @__PURE__ */ jsx(FeaturedProductWidget, { product }) });
    }
    const content = /* @__PURE__ */ jsx("div", { className: "concierge-product-details", children: products.map((p, i) => /* @__PURE__ */ jsxs(
      "div",
      {
        className: "concierge-product-detail-card",
        onClick: () => onProductClick == null ? void 0 : onProductClick(p.stacklineSku),
        role: "button",
        tabIndex: 0,
        children: [
          p.imageUrl && /* @__PURE__ */ jsx("img", { src: p.imageUrl, alt: p.title }),
          /* @__PURE__ */ jsxs("div", { children: [
            /* @__PURE__ */ jsx("div", { children: p.brand }),
            /* @__PURE__ */ jsx("div", { children: p.title }),
            /* @__PURE__ */ jsxs("div", { children: [
              "$",
              p.price != null ? Number(p.price).toFixed(2) : ""
            ] }),
            p.description && /* @__PURE__ */ jsx("div", { children: p.description })
          ] })
        ]
      },
      p.stacklineSku || i
    )) });
    if (isPdpContext) {
      const first = products[0];
      return /* @__PURE__ */ jsx(
        CollapsibleProductSummary,
        {
          product: toolProductToSectionProduct(first),
          defaultOpen: false,
          children: content
        }
      );
    }
    return content;
  }
  return null;
}
export {
  ProductDetailsPart
};
//# sourceMappingURL=ProductDetailsPart.js.map
